// extracted by mini-css-extract-plugin
export default {"header":"Header_header__asQmI","xl2":"Header_xl2__uREmI","info":"Header_info__GSK-D","bold":"Header_bold__FrgZP"};